import { FC } from "react";

import { ServiceTaskTypeEnum } from "@/domain/models/common";

import { NotesIcon } from "../blocks";
import { useTaskNotesQuery } from "../data/queries/notesQueries";
import { useServiceQuery } from "../data/queries/serviceQueries";

type DashboardTableNotesIconPropsType = {
  jobId: string;
  serviceId: string;
  taskId: ServiceTaskTypeEnum;
};

export const DashboardTableNotesIcon: FC<DashboardTableNotesIconPropsType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  // Get task's parent service data
  const { data: serviceData } = useServiceQuery({ jobId, serviceId });

  // Get task's notes
  const { data: taskNotes } = useTaskNotesQuery({ jobId, serviceId, taskId });

  const shouldShowIcon =
    Boolean(serviceData?.notes) ||
    Boolean(serviceData?.adminNotes) ||
    Boolean(taskNotes?.length);

  if (!shouldShowIcon) {
    return null;
  }

  return <NotesIcon />;
};
